import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="turbo-modal"
export default class extends Controller {
  static targets = ['div', 'div2', 'multiple', 'passwordField'];
  connect() {}

  toggle() {
    this.divTarget.classList.toggle('hidden');
  }

  toggleReload() {
    window.location.reload();
  }

  toggle2() {
    this.div2Target.classList.toggle('hidden');
  }

  toggleMultiple() {
    this.multipleTargets.forEach((element) => {
      element.classList.toggle('hidden');
    });
  }

  scrollToggle() {
    document.querySelector('body').classList.toggle('overflow-hidden');
  }

  delayedToggleMultiple() {
    this.toggleMultiple();
    setTimeout(() => {
      this.toggleMultiple();
    }, 1000);
  }
  delayedToggleMultiple2() {
    this.toggleMultiple();
    setTimeout(() => {
      this.toggleMultiple();
    }, 500);
  }

  togglePassword() {
    console.log('tpassword');
    let inputField = this.passwordFieldTarget;
    if (inputField.type === 'password') {
      inputField.type = 'text';
    } else {
      inputField.type = 'password';
    }
  }
}
